import React from 'react';
import PropTypes from 'prop-types';
import { wrapFunctionalComponent } from 'utils/framework';
import Checkbox from 'components/Inputs/Checkbox/Checkbox';
import { Text } from 'components/ui';

const DefaultPaymentCheckbox = ({
    paymentName,
    checked,
    disabled,
    setAsDefaultPaymentLabel,
    setAsDefaultPaymentNoticeLabel,
    addDefaultPaymentToProfile,
    removeDefaultPaymentFromProfile
}) => {
    const onClick = !checked ? addDefaultPaymentToProfile : removeDefaultPaymentFromProfile;

    return (
        <>
            <Checkbox
                paddingY={2}
                checked={checked}
                disabled={disabled}
                onClick={() => onClick(paymentName)}
            >
                {setAsDefaultPaymentLabel}
            </Checkbox>
            <Text
                is='p'
                fontSize='sm'
                marginTop={1}
                marginBottom={3}
                children={setAsDefaultPaymentNoticeLabel}
            />
        </>
    );
};

DefaultPaymentCheckbox.propTypes = {
    paymentName: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    setAsDefaultPaymentLabel: PropTypes.string.isRequired,
    setAsDefaultPaymentNoticeLabel: PropTypes.string.isRequired,
    addDefaultPaymentToProfile: PropTypes.func.isRequired,
    removeDefaultPaymentFromProfile: PropTypes.func.isRequired
};

export default wrapFunctionalComponent(DefaultPaymentCheckbox, 'DefaultPaymentCheckbox');
